import { Stack, Typography } from "@mui/material";
import { Progress } from "../Progress";
import { AnalyticCardWrapper } from "../AnalyticCardWrapper";
import { ReactNode } from "react";
import { RateIndicator } from "../../../../types/enums";
import { AnalyticsDataBlock } from "../AnalyticsDataBlock";

export const AccountsDiscoveryRate = ({
  total_rate,
  your_data,
  external_data,
  children,
}: {
  total_rate: number;
  your_data: number;
  external_data: number;
  external_data_indicator?: RateIndicator;
  children?: ReactNode;
  external_data_changed_at?: string | undefined;
  external_data_change?: number | undefined;
  your_data_indicator?: RateIndicator;
  your_data_changed_at?: string;
  your_data_change?: number;
}) => {
  return (
    <AnalyticCardWrapper
      title="Members Identified"
      tooltip="Rate of total discovered BC members in available data, relative to the total number of
       BC expected for analyzed accounts."
    >
      {children}
      <Stack
        gap="20px"
        flexGrow={1}
        minWidth="300px"
        justifyContent="space-between"
      >
        <Stack gap={"8px"}>
          <Stack direction="row" alignItems={"center"} gap={"8px"}>
            <Typography variant="h2" color="#051123" sx={{ fontSize: "32px" }}>
              {total_rate ?? 0}%
            </Typography>
            {/*<Tooltip*/}
            {/*  placement="bottom"*/}
            {/*  sx={{*/}
            {/*    background: "#596177E5",*/}
            {/*    fontSize: "12px",*/}
            {/*    lineHeight: "16px",*/}
            {/*  }}*/}
            {/*  arrow*/}
            {/*  title={""}*/}
            {/*>*/}
            {/*  <HelpOutlineIcon sx={{ color: "#1C3C6C" }} />*/}
            {/*</Tooltip>*/}
            <Typography variant="body1" color="#051123">
              of all members
            </Typography>
          </Stack>
          <Progress primaryValue={your_data} secondaryValue={external_data} />
        </Stack>
        <AnalyticsDataBlock
          your_data={your_data}
          external_data={external_data}
        />
      </Stack>
    </AnalyticCardWrapper>
  );
};
